import { Injectable, inject } from "@angular/core";
import { QueryEntity } from "@datorama/akita";
import { map, type Observable } from "rxjs";
import type { IClientMessage } from "../model/client-message.model";
import {
    type ClientMessageState,
    ClientMessageStore,
} from "./client-message.store";

@Injectable({
    providedIn: "root",
})
export class ClientMessageQuery extends QueryEntity<ClientMessageState> {
    protected store: ClientMessageStore;

    constructor() {
        const store = inject(ClientMessageStore);

        super(store);

        this.store = store;
    }

    selectById(wantedId: number): Observable<IClientMessage> {
        const filterBy = (clientMessage: IClientMessage) =>
            clientMessage.id == wantedId;

        return this.selectAll({
            filterBy,
            sortBy: "id",
        }).pipe(map((messages) => messages[0]));
    }

    selectFirstThree(): Observable<IClientMessage[]> {
        return this.selectAll().pipe(map((messages) => messages.slice(0, 3)));
    }
}
